export const CHANGE_SUPPLIERS_VERSION = 'CHANGE_SUPPLIERS_VERSION';
